import { useBreakpoints as o } from "@vueuse/core";
import { BREAKPOINTS as r } from "../utils/breakpoints.js";
const m = o(r).smaller("sm");
export {
  m as isMobileBreakpoint
};
